import { APIDirectory, HTTP } from '../../rest'

export const ADD_GRADE_IN_PROGRESS = "ADD_GRADE_IN_PROGRESS"

export const ADD_GRADE_COMPLETE = "ADD_GRADE_COMPLETE"

export const GET_GRADE_MASTER_DATA_IN_PROGRESS = "GET_GRADE_MASTER_DATA_IN_PROGRESS"

export const GET_GRADE_MASTER_DATA_COMPLETE = "GET_GRADE_MASTER_DATA_COMPLETE"

export const GET_GRADES_IN_PROGRESS = "GET_GRADES_IN_PROGRESS"

export const GET_GRADES_COMPLETE = "GET_GRADES_COMPLETE"

export const addGradeInProgress = () => {
    return {
        type: ADD_GRADE_IN_PROGRESS
    }
}

export const addGradeComplete = (data) => {
    return {
        type: ADD_GRADE_COMPLETE,
        data: data
    }
}

export const getMasterDataInProgress = () => {
    return {
        type: GET_GRADE_MASTER_DATA_IN_PROGRESS
    }
}

export const getGradesInProgress = () => {
    return {
        type: GET_GRADES_IN_PROGRESS
    }
}

export const getGradesComplete = (data) => {
    return {
        type: GET_GRADES_COMPLETE,
        data: data
    }
}

export const getMasterDataComplete = (data) => {
    return {
        type: GET_GRADE_MASTER_DATA_COMPLETE,
        data: data
    }
}
export const saveGradeInformation = (school, gradeList) => {
    return async dispatch => {
        try {
            dispatch(addGradeInProgress());
            let url = APIDirectory.getUpdateSchoolURL(1, school._id);
            let saveGradeInformationResult = await HTTP.PUT(url, JSON.stringify(school));
            dispatch(addGradeComplete(saveGradeInformationResult));
            return saveGradeInformationResult;
        }
        catch (error) {
            return [];
        }

    }
}
export const getGradeMasterData = () => {

    return async dispatch => {
        try {

            dispatch(getMasterDataInProgress());
            let url = APIDirectory.getGradeMasterData();
            let getGradeMasterDataResult = await HTTP.GET(url);
            dispatch(getMasterDataComplete(getGradeMasterDataResult));
            return getGradeMasterDataResult;
        } catch (error) {
            return [];
        }
    };
};


export const getGrades = (owenerId, schoolId) => {

    return async dispatch => {
        try {

            dispatch(getGradesInProgress());
            let url = APIDirectory.getGrades(owenerId, schoolId);
            let gradeList = await HTTP.GET(url);
            dispatch(getGradesComplete(gradeList));

            return gradeList;
        } catch (error) {
            return [];
        }
    };
};